const levelRenaissance = require("./grids/renaissance_game.json");
const levelPainters = require("./grids/vangoghOrGaugin_game.json");
const levelColors = require("./grids/colors_game.json");
const levelFashion = require("./grids/fashion_game.json");
const levelPicasso = require("./grids/picasso_game.json");
const levelStreetArt = require("./grids/streetart_game.json");
const levelFoodie = require("./grids/foodie_game.json");
const levelArchi = require("./grids/archi_game.json");
const levelRijk = require("./grids/rijk_game.json");

const levels = [
  levelRenaissance,
  levelPainters,
  levelColors,
  levelFashion,
  levelPicasso,
  levelStreetArt,
  levelFoodie,
  levelArchi,
  levelRijk,
];

function addUrls(image, id) {
  return {
    ...image,
    url: `assets/${id}/${image.id}.jpg`,
    thumbUrl: `thumbs/${id}/${image.id}.jpg`,
  };
}

const updatedLevels = levels.map((l) => {
  return {
    ...l,
    images: l.images.map((i) => addUrls(i, l.id)),
  };
});

module.exports = updatedLevels;
